import { Directive, ElementRef } from '@angular/core';
import { ThemeService } from 'app/private/_core/_services/theme.service';

@Directive({
    selector: '[appSvgPathColor]',
    standalone: false
})
export class SVGPathColorDirective {
	constructor(
		el: ElementRef,
		private themeService: ThemeService,
	) {
		el.nativeElement.style.fill = this.themeService.color;
	}
}
